import { Clock } from "lucide-react";

const DOW = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
const fmtDay = (ds) => { const d = new Date(ds + "T00:00:00"); return `${DOW[d.getDay()]} ${d.getDate()}/${d.getMonth() + 1}`; };

export function ClosedBanner({ opening, accent }) {
  let msg;
  if (!opening.next_date) msg = "Il concorso non prevede altri giorni di gioco.";
  else if (opening.today) msg = `Si gioca oggi dalle ${opening.next_time}${opening.hours ? ` (orario ${opening.hours})` : ""}.`;
  else msg = `Prossima apertura: ${fmtDay(opening.next_date)}${opening.next_time ? ` dalle ${opening.next_time}` : ""}${opening.hours ? ` · orario di gioco ${opening.hours}` : ""}.`;
  return (
    <div className="mx-auto mb-6 max-w-lg rounded-2xl border border-white/20 bg-black/40 backdrop-blur-md px-5 py-4 text-left text-white shadow-lg" style={{ borderLeft: `4px solid ${accent || "#f59e0b"}` }} data-testid="closed-banner">
      <p className="font-display font-bold flex items-center gap-2 text-base md:text-lg"><Clock className="h-5 w-5" style={{ color: accent || "#f59e0b" }} /> Il concorso è chiuso in questo momento</p>
      <p className="text-sm text-white/80 mt-1" data-testid="closed-banner-next">{msg}</p>
    </div>
  );
}
